/** Aligné backend b2bProfessionalProfile (SIREN 9 chiffres). */

export function normalizeSiren(value) {
  if (value == null) return null;
  const digits = String(value).replace(/\D/g, '');
  return digits || null;
}

export function isValidSirenDigits(digits) {
  return typeof digits === 'string' && /^\d{9}$/.test(digits);
}

export function validateSirenInput(raw) {
  const trimmed = typeof raw === 'string' ? raw.trim() : '';
  if (!trimmed) {
    return { ok: false, message: 'SIREN requis (9 chiffres).' };
  }
  const normalized = normalizeSiren(raw);
  if (!isValidSirenDigits(normalized)) {
    return { ok: false, message: 'SIREN invalide : 9 chiffres attendus.' };
  }
  return { ok: true, normalized };
}
